import React from "react";
import PropTypes from "prop-types";
import { FaFileInvoice, FaSpinner } from "react-icons/fa";

/**
 * Xem hóa đơn = nhúng thẳng file PDF (presigned inline URL từ API invoice_detail.view_url).
 * Không nhúng app doc-flatform, không postMessage — chỉ là 1 file PDF.
 */
const InvoicePreviewFrame = ({ url, loading }) => {
  if (loading) {
    return (
      <div className="tw-h-full tw-flex tw-items-center tw-justify-center tw-text-geist-fg-3">
        <FaSpinner className="tw-animate-spin tw-mr-2" /> Loading PDF…
      </div>
    );
  }
  if (!url) {
    return (
      <div className="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-geist-fg-3 tw-p-6">
        <FaFileInvoice size={36} className="tw-mb-3 tw-text-geist-border-2" />
        <p className="tw-text-sm tw-m-0">Pick an invoice to preview the PDF here.</p>
      </div>
    );
  }
  return (
    <iframe
      title="invoice-pdf"
      src={url}
      className="tw-w-full tw-h-full tw-border-0"
    />
  );
};

InvoicePreviewFrame.propTypes = {
  url: PropTypes.string,
  loading: PropTypes.bool,
};

export default InvoicePreviewFrame;
